module.exports = __webpack_public_path__ + "static/media/3.31884d6d.svg";